// extracted by mini-css-extract-plugin
export default {"ctaMenu":"SpySearch_ctaMenu__OwTdG"};